import {get,post,url} from "../http"

class Teacher{
    //教师列表
    @url("tea/list")
    @get
    gettealist(){}

    //教师详情
    @url("tea/one")
    @get
    getteadetail(){}
}

export default new Teacher()